<template>
  <div class="timer">
    <h1>TIME REMAINING</h1>
    <hr />
    <Countup></Countup>
  </div>
</template>

<script>
import Countup from "./Countup";

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: { Countup }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 40px;
  letter-spacing: 10px;
}
hr {
  max-width: 500px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.timer {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
